import { ItemViewModel } from '../../ItemViewModel';

export class RegistrationDetailsFormLookups {
    stateProvinces: ItemViewModel[] = [];
    countries: ItemViewModel[] = [];
}
